export default {
  sections: [
    {
      title: 'Signing up to Kintell',
      ref: 'signUp',
      questions: [
        {
          q: 'Can anyone sign up to Kintell?',
          a: 'Yes! It’s free and very easy to join Kintell, so you can browse our community of Advisors and make bookings. You can sign up {signUp}. For info on how to become an Advisor (which is slightly different) see {becomeAdvisor}.',
          becomeAdvisor: 'below',
          signUp: 'here'
        },
        {
          q: 'Can I sign up on my phone?',
          a: 'You can sign up on any device with a web browser - Kintell is a web app so doesn’t need you to install anything.\n'
        },
        {
          q: 'What details do I need to give to sign up?',
          a: 'We need your name, email, location, mobile number and a profile picture. That’s it! It’s very quick, and very easy.'
        },
        {
          q: 'How much does it cost to sign up to Kintell?',
          a: 'Nothing! It’s completely free. You only need to pay when you actually make a booking with an Advisor. '
        },
        {
          q: 'What’s the difference between being invited and signing up on the website?',
          a: 'If you’re invited to Kintell by a member, the signing-up process is a little simpler and quicker. Also, your inviter will earn pro bono credit, if you sign up using their invite link.',
        },
        {
          q: 'Why do you need a photo?',
          a: 'Kintell is about real people, so profile photos are essential. A picture verifies that you\'re genuine to other users.'
        },
      ]
    },
    {
      title: 'Making a booking',
      ref: 'makeBooking',
      questions: [
        {
          q: 'What is a booking?',
          a: 'A booking is a video conference with an Advisor, held on the Kintell platform. Bookings are the bread and butter of Kintell.',
        },
        {
          q: 'How do I make a booking with an Advisor?',
          a: 'Once you’ve selected your preferred Advisor, you simply click on Book Now, choose your preferred times, and enter your payment details (if you haven’t previously). '
        },
        {
          q: 'How much do bookings cost?',
          a: 'Advisors set their own fees, which are charged per half hour. Check out our {pricing} page for more details.',
          pricing: 'Pricing'
        },
        {
          q: 'What happens if an Advisor can’t make my suggested times?',
          a: 'If an Advisor can’t make the times you’ve selected, they will either send some new times or cancel the booking (if they’re too busy). '
        },
        {
          q: 'How will I know if my booking has been accepted?',
          a: 'We send you notifications during each phase of the booking process, so you’ll always know what’s going on. We’ll also add the booking to the {bookingDashboard} section of your Dashboard.',
          bookingDashboard: 'Bookings'
        },
        {
          q: 'Will you remind me when a booking is coming up?',
          a: 'Yes! We’ll remind you via email, SMS, and on the kintell.com site, so you never miss a booking.'
        },
        {
          q: 'What if I want to cancel an upcoming booking?',
          a: 'You are free to cancel at any time, but there may be a charge depending on how close it is to the booking date - for more info check out our {cancellation}.',
          cancellation: 'Cancellations Policy'
        },
        {
          q: 'What if an Advisor cancels my booking?',
          a: 'We encourage Advisors not to do this, and if it happens regularly their ratings are affected. However, sometimes life gets in the way. Rest assured, you’ll be given a full refund and as much notice as possible.'
        },
      ]
    },
    {
      title: 'Video sessions',
      ref: 'videoConsult',
      questions: [
        {
          q: 'Do I need any special equipment?',
          a: 'Nope. All Kintell video sessions are on the kintell.com site, which you can use on your phone, tablet, laptop or desktop. If you’re using a phone you’re all good to go, and if using a laptop or desktop you need to ensure you have a working camera and microphone.\n',
        },
        {
          q: 'How about a headphone?',
          a: 'We recommend using headphones. Because they eliminate the echo of sound through your device’s speakers.'
        },
        {
          q: 'What if my device is too old?',
          a: 'If your device is too old, it may have a negative impact on your video chat experience. This is because the older devices (usually tablets or phones) can’t process the video in real time.'
        },
        {
          q: 'What browser or operating system works best with Kintell?',
          a: 'Kintell video platform works great on latest version of Chrome installed on a Mac or Windows laptop or desktop. We don’t recommend Firefox, Safari or other browsers, although it works on those in most cases.',
        },
        {
          q: 'Will I be able to test my setup?\n',
          a: 'Yes, before each booking you’ll have the chance to see if your camera and microphone are working, so you don’t waste any of your booking setting everything up!'
        },
        {
          q: 'What happens if I have a poor internet connection?',
          a: 'We’ve developed the Kintell video platform so that it prioritises audio over video, so even if you have a dodgy internet connection your conversation should go uninterrupted. '
        },
        {
          q: 'Can I send text messages or files?',
          a: 'Yes, we’ve included a text chat facility in the video platform so that you can send messages when in a video sessions (links, screenshots, pdf files, whatever is needed!).',
        },
        {
          q: 'What if I want to end the call early?',
          a: 'You can end the call whenever you like, but keep in mind that you’ll be charged for the time you booked out. However, if you’re unhappy with your Advisor, or it isn’t a good fit, then you can end your first session within the first 5 minutes without charge. '
        },
        {
          q: 'What if the call goes over the booked time?',
          a: 'If your booking goes on longer than expected it’s up to you and the Advisor as to whether you should continue.'
        },
        {
          q: 'Can I share my screen?',
          a: 'Yes, if you join the session on a laptop/desktop computer. If you join on mobile devices, you can’t share your screen, but if the other party share their screen you can view it on your end.'
        },
        {
          q: 'What if I miss my Kintell booking?',
          a: 'If you fail to show up for your booking, it will harm your Kintell rating. If you have missed two video sessions in a row where you were the Advisor, we\'ll convert your Kintell Card to a draft. This is to encourage our users only to confirm bookings that they\'re able to carry out.',
        },
      ]
    },
    {
      title: 'Ratings & reviews',
      ref: 'ratings',
      questions: [
        {
          q: 'When are Advisor reviews posted?',
          a: 'Reviews are posted after every video session. We make it compulsory (you can’t do anything else until you complete the review) to ensure Learners have all the information they need to make informed choices about who they book.',
        },
        {
          q: 'Do Advisors leave review for Learners as well?',
          a: 'Yes, however, the Learners’ rating and review is not publicly visible. It is only when a Learner sends a booking request to an Advisor, their past ratings and reviews can be viewed by that Advisor.'
        },
        {
          q: 'How can I post a review of an Advisor?',
          a: 'You have to book and carry out a video session with an Advisor in order to leave a review of them - you’ll be prompted once the call is finished. '
        },
        {
          q: 'What impact do reviews have?',
          a: 'Advisors with poor reviews are automatically given less prominence than those with good reviews. In addition to this, there are other factors such as frequency of cancellations that impact the rating of an Advisor profile.'
        },
      ]
    },
    {
      title: 'Making payments',
      ref: 'makePayments',
      questions: [
        {
          q: 'When do I pay for a booking?',
          a: 'We take payment details when you make a booking, but only take the actual payment when your booking is approved by the Advisor.',
        },
        {
          q: 'How can I pay?',
          a: 'We accept all major credit and debit cards.'
        },
        {
          q: 'Can I get a receipt?',
          a: 'Yes, we send a booking summary and receipt to all users on completion of the bookings.'
        },
        {
          q: 'Do you store my card details?',
          a: 'We don’t store your card details on our servers, instead we use the Stripe payment gateway, which is as secure and encrypted as it is possible to be.'
        },
      ]
    },
    {
      title: 'Becoming an Advisor',
      ref: 'becomeAdvisor',
      questions: [
        {
          q: 'How do I become a Kintell Advisor?',
          a: 'You need to {signUp} to Kintell and then create a {kintellCards} (on an area of knowledge you’re offering advice in). This card will be evaluated by the Kintell Team, and if approved you’ll be made an official Kintell Advisor, and be able to start taking bookings :)',
          signUp: 'sign up',
          kintellCards: 'Kintell Card'
        },
        {
          q: 'How do you ensure quality is high?',
          a: 'Our approach is two-fold, with each new Advisor having to be approved before going live, and ongoing monitoring of reviews and performance criteria affecting profile ratings.',
        },
        {
          q: 'When can I provide bookings?',
          a: 'It’s entirely up to you when you make yourself available for bookings - it’s all customisable within the {workingHours} section of your dashboard. ',
          workingHours: 'Working Hours'
        },
        {
          q: 'Can I do this around my day job?',
          a: 'Yes! Empowering people to make full use of their knowledge and expertise was one of the founding aims of Kintell.'
        },
        {
          q: 'Is there a minimum amount of time I have to commit?',
          a: 'Nope. In fact you can set a maximum monthly consultation cap, so once the limit is reached, learners won’t be able to book you. ',
        },
        {
          q: 'Can I integrate my Google calendar with Kintell?',
          a: 'Yes, we support syncing Google, Outlook and many other calendars. This is to ensure people can only book you when you are really available so you don’t worry about conflicts in your schedule.'
        },
        {
          q: 'What can I advise in?',
          a: 'Anything you like, as long as it doesn’t break our {code}, and that you have the experience and knowledge to make you a good Advisor :)',
          code: 'Code of Conduct'
        },
        {
          q: 'What if I let a booking request expire?',
          a: 'The Kintell listings have been designed to favour Advisors who respond to booking requests quickly. If you let a booking expire, it will harm your Kintell rating. If you\'ve had two booking requests that have expired, where you\'ve had 48 hours or more to respond, we\'ll convert your Kintell Card to a draft. This is to make sure that our users are only book Advisors that respond to their requests.',
        },
      ]
    },
    {
      title: 'Kintell Cards',
      ref: 'kintellCards',
      questions: [
        {
          q: 'What is a Kintell Card?',
          a: 'Every Advisor can publish as many Kintell Cards as they like, each covering an area of knowledge they would like to provide advice upon. For example a languages teacher may want to post one card on ‘Speaking English’ and another on ‘Written English’.',
        },
        {
          q: 'Are Kintell Cards findable by Google?',
          a: 'By default, all Kintell Cards are listed publicly on the Kintell.com site, and Google will pick them up. However for those who would prefer to keep things quiet you can set some of your cards as Private, which means only people who you share the link with will be able to view these cards and use them to book you in.'
        },
        {
          q: 'What is considered a ‘good’ Kintell card?',
          a: 'Check out {example} of a well constructed Kintell Card. It has a clearly defined topic, a number of sub-topics, a well-written overview of relevant experience, a number of supporting articles, and a link to a LinkedIn profile so people can find out more. ',
          example: 'this example'
        },
        {
          q: 'How do I share my Kintell Cards with others?',
          a: 'The simplest way is to copy the share link from your {kintellCards} page in your dashboard.',
          kintellCards: 'Kintell Cards'
        },
        {
          q: 'What’s a Private Kintell Card?',
          a: 'Private Kintell Cards are not searchable on Kintell and don’t have ratings and reviews. They also attract much lower admin fee (see {bookingFee} for details). For example, after a first session with a new Learner you could use these cards for your ongoing follow-up meetings. Or you could use a FREE one for your work meetings with your colleagues or existing clients which won’t attract any admin fee.',
          bookingFee: 'this section'
        },
      ]
    },
    {
      title: 'Promoting your Kintell Profile',
      ref: 'promoting',
      questions: [
        {
          q: 'How can I use different types of Kintell Cards?',
          a: 'You can create multiple Kintell cards for specific purposes. For example, {kintellUserAngela} offers three listed Kintell Cards: a free introductory card to accumulate ratings & reviews, a card with her standard offering and one card with a niche, fun topic. If you have a follow-up session, you might want to use a private Kintell card. For paid sessions, they only cost you 3% admin fee.',
          kintellUserAngela: 'Kintell user Angela'
        },
        {
          q: 'How can I make my Kintell Card more bookable?',
          a: 'Make sure your social media links, especially LinkedIn, are up to date to verify that you are who you say you are. Also, when writing your Kintell Card, make sure to have relevant and popular keywords (lawyer, digital marketing, accountant, etc.). It\'s through the keywords that people will find you.'
        },
        {
          q: 'How do I accumulate ratings and reviews?',
          a: 'A good idea to build your profile is to set your listed Kintell Card fee to zero temporarily. This will generate the initial ratings and reviews needed for users you don\'t know to book you. Our algorithms favour cards with more reviews, so when you\'ve acquired a few, you can introduce a fee back to your card. You can also share your card with existing clients for follow-up chats, and build your reviews that way.',
        },
        {
          q: 'How do I spread the word on social media?',
          a: 'Sharing your Kintell Cards on your Social Networks is a great way to bring users to your profile. {followJaquesExample} and share it on LinkedIn to reach a professional audience. Or share your latest review on Instagram and Facebook to spread the word about your offer!',
          followJaquesExample: 'Follow Jaques example',
        },
        {
          q: 'What else can I do to get the word out?',
          a: 'Do you give workshops or facilitate meet-ups? Provide the participants with the URL to your Kintell Cards to offer them a one-to-one follow-up session. Maybe you\'ve met a new potential client who\'s offered you a coffee to "pick your brain"? Ask them to book you through Kintell. When signing up, they\'ll receive {signUpCredit} Kintell Credit to use for the booking, and you\'ll get paid your full rate, and accumulate rating and reviews to build your global reputation as an advisor.',
        },
      ]
    },
    {
      title: 'Receiving Payments',
      ref: 'receivingPayments',
      questions: [
        {
          q: 'How do I get paid as an Advisor?',
          a: 'When you receive your first booking request as an Advisor, we’ll ask you for your bank details so we can pay you. Due to financial regulations we also have to ask for your date of birth so you can be verified as a real person (more information {here}).',
          here: 'here'
        },
        {
          q: 'How long does it take to set up?',
          a: 'Popping in your bank details is a doddle, and then it usually takes a day or so before your account details are verified. Stripe, our payment processing partner, will be in touch if they need further details in order to confirm you aren’t a money launderer :)',
        },
        {
          q: 'When do I get paid?',
          a: 'We release the funds to you within a week of the booking being completed.'
        },
      ]
    },
    {
      title: 'Admin fee',
      ref: 'bookingFee',
      questions: [
        {
          q: 'Is there an admin fee?',
          a: 'Yes, we charge a percentage of the total payable ranging from 3% to 15% on all paid bookings in order for us to cover company costs. As an Advisor, it’s worth keeping this in mind when deciding your rate.\n',
          points: [
            {
              heading: 'FREE Kintell Cards: ',
              body: 'There is no admin fee on bookings made on a FREE Kintell Card (whether standard or private).',
            },
            {
              heading: 'Private Kintell Cards: ',
              body: 'We charge a 3% fee to cover payment gateway costs. For international bookings, we charge 1% extra to cover currency conversions.'
            },
            {
              heading: 'Standard Kintell Cards: ',
              body: 'We charge a 15% fee to cover company costs (for domestic and international bookings).',
            }
          ]
        },
        {
          q: 'What is an international booking?',
          a: 'Any booking that involves users in different countries is treated as international.'
        },
        {
          q: 'What countries are supported internationally?',
          a: 'Anyone from anywhere with a valid credit/debit card can make a booking with advisors in Australia, New Zealand, UK, Sweden and Denmark. We’re working hard to support more countries (coming soon).'
        },
        {
          q: 'Would these fees change?',
          a: 'We’ll keep you up to date if there is any major change to admin fees. You can always check this section for updates.'
        },
      ]
    },
    {
      title: 'Rewards & Invites',
      ref: 'rewards',
      questions: [
        {
          q: 'What are Kintell Rewards?',
          a: 'All users can earn free Pro Bono time to spend on video sessions by inviting their friends and colleagues to Kintell. It’s a great way of earning free credit whilst improving the Kintell community. Check out the {myInvites} section for more details.',
          myInvites: 'My Invites'
        },
        {
          q: 'How can I send out invites?',
          a: 'We’ve made it super-simple to invite people to Kintell - just go to {myInvites} and pop in their name and email and we’ll do the rest.',
          myInvites: 'My Invites'
        },
        {
          q: 'How can I track my Rewards?',
          a: 'In the {myInvites} section you’ll find who you’ve invited, their status, and how much you’ve earnt - you get 10 minutes of Pro Bono time when invitees sign up, and 30 minutes if they become an Advisor :)',
          myInvites: 'My Invites'
        },
        {
          q: 'How can I spend my Rewards Pro Bono credit?',
          a: 'We encourage all of our Advisors to give something back to the community by giving up some time for Pro Bono bookings every month. You can use the filter bar to show those with Pro Bono availability.'
        },
      ]
    },
  ]
}
